<template>
  <div class="aifv-evaluate">
    <div class="box">
      <div class="box-title">
        <img src="@/assets/images/aifv/img23.png" class="icon-title" alt="">
        <span class="title-txt">AIFV报告所属术者: <span class="name-txt">{{ aifvUserInfo && aifvUserInfo.hcpName }}</span></span>
      </div>
      <div class="box-div">
        <div class="div-title">1.<span class="red_col">*</span>请针对本次专业支持,给予评价</div>
        <div class="div-content">
          <div class="txt1">术前沟通</div>
          <div class="rate-con">
            <van-rate :readonly="!isFeedBack" allow-half v-model="interactScore" :size="24" color="#EB1700" />
            <span class="txt2">{{ this.interactScore * 2 }}分</span>
          </div>
        </div>
        <div class="div-content">
          <div class="txt1">术中配合</div>
          <div class="rate-con">
            <van-rate :readonly="!isFeedBack" allow-half v-model="teachingScore" :size="24" color="#EB1700" />
            <span class="txt2">{{ this.teachingScore * 2 }}分</span>
          </div>
        </div>
        <div class="div-content">
          <div class="txt1">术后复盘</div>
          <div class="rate-con">
            <van-rate :readonly="!isFeedBack" allow-half v-model="replayScore" :size="24" color="#EB1700" />
            <span class="txt2">{{ this.replayScore * 2 }}分</span>
          </div>
        </div>
        <div class="div-title div-title2">2.意见反馈</div>
        <!-- 反馈输入框 -->
        <van-field :readonly="!isFeedBack" type="textarea" class="feedback-input" rows="3" autosize maxlength="200"
          show-word-limit v-model="feedbackText" placeholder="请输入您的反馈~" />
      </div>

      <!-- 提交按钮 -->
      <van-button v-if="isFeedBack && userInfo.memberType !== 1" round block class="submit-btn"
        @click="handleFeedBack">提交</van-button>
    </div>
  </div>
</template>

<script>
import { sendFeedback } from '@/api/api'
import { getInfoByMultiCode } from '@/api/aifv'
import { debounce } from '@/utils/util'
import withRouteTracking from '@/utils/withRouteTracking'
const UserProfile = {
  data () {
    return {
      interactScore: 0,
      teachingScore: 0,
      replayScore: 0,
      feedbackText: '',
      aifvUserInfo: {},
      isFeedBack: true
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    },
  },
  mounted () {
    if (this.userInfo.memberType === 1) {
      this.$toast('仅术者身份可以评价')
      setTimeout(() => {
        this.$router.push({
          path: '/home'
        })
      }, 3000)
      return
    }
    // 获取用户信息
    getInfoByMultiCode({ multiCode: this.$route.query.aifvMulticode }).then(res => {
      this.aifvUserInfo = res.data
    }).catch((err) => {
      console.error(err)
    })
  },
  methods: {
    // 反馈操作
    handleFeedBack: debounce(function() {
      if (this.interactScore <= 0) {
        this.$toast('请针对本次专业支持,给予评价!')
        return
      }
      // type、反馈类型1系统反馈意见2推荐反馈意见3每日答题反馈意见6aifv
      // baseTitle 被评价人的multicode
      let params = {
        type: 6,
        baseTitle: this.aifvUserInfo ? this.aifvUserInfo.multiCode : '',
        title: 'AIFV员工看术者给术者评价',
        content: this.feedbackText,
        state: 2,
        userName: this.userInfo.realName,
        userId: this.userInfo.id,
        role: this.userInfo.roles[0],
        phone: this.userInfo.phone,
        email: this.userInfo.email,
        openId: this.userInfo.iepOpenId,
        employeeId: this.$route.query.employeeId,
        interactScore: this.interactScore * 2,
        teachingScore: this.teachingScore * 2,
        replayScore: this.replayScore * 2
      }
      sendFeedback(params).then(res => {
        if (res.code === 0) {
          this.isFeedBack = false
          this.$toast('评价成功，感谢您的评价！')
          setTimeout(() => {
            this.$router.push({
              path: '/home'
            })
          }, 3000)
        } else {
          this.$toast(res.msg)
        }
      })
    }, 1000)
  }
}
export default withRouteTracking(UserProfile)
</script>
<style lang="less" scoped>
.aifv-evaluate {
  background-image: url('../../assets/images/aifv/img22.png');
  background-size: cover;
  width: 100vw;
  min-height: 100vh;
  padding: 14px 16px;
  box-sizing: border-box;
  overflow: hidden;

  .box {
    background-color: #fff;
    border-radius: 8px;
    padding: 12px;
    box-sizing: border-box;
    height: 100%;

    .box-title {
      background-color: rgba(255, 91, 12, 0.08);
      height: 37px;
      display: flex;
      align-items: center;
      padding-left: 10px;
      border-radius: 8px;

      .icon-title {
        width: 11px;
        display: block;
        margin-right: 8px;
      }

      .title-txt {
        color: #EB1700;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-size: 14px;

        .name-txt {
          font-weight: 500;
        }
      }
    }

    .div-title {
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      font-size: 14px;
      color: #000000;
      line-height: 20px;
      margin-top: 12px;

      .red_col {
        color: #FF0000;
      }

      &.div-title2 {
        margin-top: 24px;
        margin-bottom: 8px;
      }
    }

    .feedback-input {
      width: 322px;
      border-radius: 8px;
      border: 1px solid #CCCDD0;
      margin-bottom: 36px;
    }

    .div-content {
      margin-top: 16px;
      padding-bottom: 4px;

      .txt1 {
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 400;
        font-size: 14px;
        color: #000000;
        line-height: 20px;
        margin-bottom: 10px;
      }

      .rate-con {
        display: flex;
        align-items: center;

        .txt2 {
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-size: 14px;
          color: #000000;
          margin-left: 12px;
          line-height: 24px;
          position: relative;
          top: 2px;
        }
      }
    }
  }

  .submit-btn {
    background: #EB1700;
    box-shadow: 0px 2px 4px 0px rgba(255, 91, 12, 0.25);
    color: #FFFFFF;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-size: 16px;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/AIFV/evaluateAIFV.vue